<template>
	<div class="home-introduction">
		<div class="all-services">
			<div class="service-banner">
				<div class="service-banner-cover">
					<h1>Szeroki zakres usług księgowych</h1>
				</div>
			</div>
			<div class="services-grid">
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text">
						- Prowadzenie ksiąg rachunkowych
					</div>
				</div>
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text">
						- Powadzenie ksiąg przychodów i rozchodów
					</div>
				</div>
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text">
						- Prowadzenie ewidencja przychodów
					</div>
				</div>
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text">- Obsługa kadrowa</div>
				</div>
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text">- Obsługa płacowa</div>
				</div>
				<div class="service-entry">
					<div class="service-icon"></div>
					<div class="service-text"></div>
					- Dofinansowania i rozpoczęcie działalności
				</div>
				<div class="service-button">
					<router-link
						class="intro-btn"
						tag="input"
						type="button"
						value="Poznaj szegóły oferty"
						to="/oferta"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@include media-breakpoint-up(xs) {
	.intro-btn {
		@include btn-full;
	}
	.home-introduction {
		min-height: 100vh;
		@include d-flex-column;
	}

	.all-services {
		@include d-flex-column;
		padding: 0;
		margin: 0;
		overflow: hidden;
		box-sizing: border-box;
	}
	.service-banner {
		position: relative;
		background: url('../assets/services-header.jpeg') center center
			no-repeat;
		background-size: cover;
		color: #fff;
		overflow: hidden;
		@include d-flex-column;
		align-items: center;
		justify-content: center;
		.service-banner-cover {
			text-transform: uppercase;
			font-weight: 300;
			flex: 1;
			@include d-flex-column;
			align-items: center;
			justify-content: center;
			padding: 3em;
			width: 100%;
			background: rgba($color: $main-darkest, $alpha: 0.8);
		}
	}
	.services-grid {
		padding: 0.4em;
		.service-entry {
			@include d-flex-column;
			padding: 10px;
			margin: 0.1em auto;
			.service-icon {
				i {
					width: 3em;
					height: auto;
				}
			}
			.service-text {
				margin-top: 5px;
				text-align: left;
			}
		}
	}
	.service-button {
		@include d-flex-column-center-center;
	}
}
@include media-breakpoint-up(sm) {
}
@include media-breakpoint-up(md) {
	.all-services {
		border-radius: 10px;
		margin: 6em auto;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		@include d-flex-row;
	}
	.service-banner {
		width: 100%;
		max-width: 400px;
	}

	.services-grid {
		flex: 2;
		padding: 1em;
		font-size: 1.2em;
	}
}
@include media-breakpoint-up(lg) {
}
@include media-breakpoint-up(xl) {
}
</style>
